import { useTranslations } from 'next-intl';

const ScrollToTop = () => {
  const tGlobal = useTranslations('Global');

  return (
    <>
      <p onClick={() => window.scrollTo({ top: 0, behavior: `smooth` })}>
        {tGlobal('scrollToTop')}
      </p>
      <style jsx>{`
        p {
          text-align: center;
          cursor: pointer;
          text-decoration: underline;
          color: var(--clr-tertiary-1);
        }
      `}</style>
    </>
  );
};

export default ScrollToTop;
